import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CMRequests = _resolveComponent("CMRequests")!
  const _component_CMDocument = _resolveComponent("CMDocument")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "py-0" }, {
    default: _withCtx(() => [
      (_ctx.isAccountingUser && _ctx.chatObjectType)
        ? (_openBlock(), _createBlock(_component_CMRequests, {
            key: 0,
            type: _ctx.chatObjectType,
            info: _ctx.info,
            smartMessages: _ctx.chatMessagesNotReply,
            onSendMessage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sendMessage($event))),
            onInsertQuestion: _cache[1] || (_cache[1] = ($event: any) => (_ctx.insertQuestion($event)))
          }, null, 8, ["type", "info", "smartMessages"]))
        : (_ctx.chatObjectType === 'Document' && _ctx.answersRequired && _ctx.showChatManager)
          ? (_openBlock(), _createBlock(_component_CMDocument, {
              key: 1,
              id: _ctx.id,
              smartMessages: _ctx.chatMessagesNotReply,
              documentInfo: _ctx.info,
              onAnswers: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendAnswers($event))),
              onReduce: _cache[3] || (_cache[3] = ($event: any) => (_ctx.reduce($event)))
            }, null, 8, ["id", "smartMessages", "documentInfo"]))
          : _createCommentVNode("", true),
      (!_ctx.showChatManager && _ctx.answersRequired)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 2,
            "no-gutters": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_icon, {
                    icon: "$live_help",
                    size: "small",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.reduce({ value: false })))
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}